<template>
  <modal class="modalCG topModal" @before-open="iphoneModalsSet" @before-close="closingModal" name="modalRegister" height="auto" :adaptive="true" :scrollable="true">
    <div class="modal-box">
      <div class="modal-header">
        <h2>Registriere Dich <br />bei couchgourmet</h2>
        <span class="close" @click.prevent="toggleModal">
          <icon name="close" scale="2"></icon>
        </span>
      </div>
      <div class="modal-body text-center">
        <form>
        <div class="form-field sized">
          <label for="register_firstname">Vorname</label>
          <input
                  type="text"
                  id="register_firstname"
                  placeholder="Vorname"
                  v-model="user.firstname"
                  name="firstname"
                  v-validate="'required|max:255'"
                  :class="{'error': errors.has('firstname') }"
                  data-vv-as="Vorname"
                  ref="registerName"
          >
          <span v-show="errors.has('firstname')" class="errorMsg">{{ errors.first('firstname') }}</span>
        </div>
        <div class="form-field sized">
          <label for="register_lastname">Nachname</label>
          <input
              type="text"
              id="register_lastname"
              placeholder="Nachname"
              v-model="user.lastname"
              name="lastname"
              v-validate="'required|max:255'"
              :class="{'error': errors.has('lastname') }"
              data-vv-as="Nachname"
              ref="registerSurname"
          >
          <span v-show="errors.has('lastname')" class="errorMsg">{{ errors.first('lastname') }}</span>
        </div>
        <div class="form-field sized">
          <label for="register_password">Passwort</label>
          <input
                  type="password"
                  id="register_password"
                  placeholder="Passwort"
                  v-model="user.password"
                  name="password"
                  v-validate="'required|min:6|max:50'"
                  :class="{'error': errors.has('password') }"
                  data-vv-as="Passwort"
                  ref="registerPass"
          >
          <span v-show="errors.has('password')" class="errorMsg">{{ errors.first('password') }}</span>
        </div>

        <div class="form-field sized">
          <label for="passwordConfirmation">Passwort bestätigen</label>
          <input
                  v-model="user.passwordConfirmation"
                  name="passwordConfirmation"
                  v-validate="'required|confirmed:password'"
                  :class="{'error': errors.has('passwordConfirmation') }"
                  type="password"
                  placeholder="Passwort bestätigen..."
                  id="passwordConfirmation"
                  data-vv-as="Passwort bestätigen"
                  ref="registerPassConf"
          >
          <span v-show="errors.has('passwordConfirmation')"
                class="errorMsg">{{ errors.first('passwordConfirmation') }}</span>
        </div>
        <div class="form-field sized">
          <label for="register_email">Email</label>
          <input
            type="text"
            id="register_email"
            placeholder="Email"
            v-model="user.email"
            name="email"
            v-validate="'required|email'"
            :class="{'error': errors.has('email') }"
            data-vv-as="Email"
            ref="registerEmail"
            @keyup.enter="register"
          >
          <span v-show="errors.has('email')" class="errorMsg">{{ errors.first('email') }}</span>
          <span v-show="bag.has('email:duplicate')" class="errorMsg">{{ bag.first('email:duplicate') }}</span>
        </div>
        <label @click="acceptsMarketing = !acceptsMarketing" class="checkbox ml-2 mt-4">
              <span>Bitte informiere mich über Neuigkeiten rund um couchgourmet</span>
          <input type="checkbox" :checked="acceptsMarketing">
          <span class="checkmark"></span>
        </label>
        </form>
        <span><a @click.prevent="toggleLogin">Schon registriert? Jetzt <u>anmelden</u>.</a></span>
      </div>
      <div class="modal-action">
        <button class="btn green" @click.prevent="register">Erstelle meinen couchgourmet Account</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import { EventBus } from '@/assets/js/event-bus.js'
  import api from '@/assets/js/api.js'
  import { mapActions } from 'vuex'
  import { ErrorBag } from 'vee-validate'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'register',
    mounted () {
      EventBus.$on('toggleRegisterModal', () => {
        this.toggleModal()
      })
      EventBus.$on('escKey', () => {
        this.showRegister = false
        this.clearModal()
        this.$modal.hide('modalRegister')
      })
    },
    beforeDestroy () {
      EventBus.$off('toggleRegisterModal')
      EventBus.$off('escKey')
    },
    mixins: [helpers, formatting],
    data () {
      return {
        bag: new ErrorBag(),
        showRegister: false,
        user: {
          firstname: '',
          lastname: '',
          email: '',
          password: '',
          passwordConfirmation: ''
        },
        acceptsMarketing: false,
        saveToast: null
      }
    },
    methods: {
      ...mapActions([
        'getAuthAccount'
      ]),
      closingModal () {
        this.showRegister = false
        this.iphoneModalsUnset()
      },
      closeModal (e) {
        if (e.target.className === this.$refs.modalbackround.className) {
          this.toggleModal()
        }
      },
      toggleModal () {
        var vm = this
        vm.showRegister = !vm.showRegister
        this.showRegister ? this.$modal.show('modalRegister') : this.$modal.hide('modalRegister')
      },
      clearModal () {
        var vm = this
        vm.errors.clear()
        if (vm.showRegister) {
          document.body.classList.add('scrollbar')
          document.getElementById('app').classList.add('overflow-hidden')
        } else {
          document.body.classList.remove('scrollbar')
          document.getElementById('app').classList.remove('overflow-hidden')
        }
        vm.user.email = ''
        vm.user.firstname = ''
        vm.user.lastname = ''
        vm.user.password = ''
        vm.user.passwordConfirmation = ''
        vm.acceptsMarketing = false
      },
      toggleLogin () {
        this.toggleModal()
        EventBus.$emit('toggleLoginModal')
      },
      register () {
        var vm = this
        vm.$validator.validateAll().then((result) => {
          if (result) {
            if (!vm.saveToast) {
              vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                icon: 'info'
              })
              vm.user.accepts_marketing = vm.acceptsMarketing
              api.saveUser(vm.user).then(
                response => {
                  vm.saveToast.goAway(100)
                  vm.saveToast = null
                  vm.$toasted.success('Willkommen bei couchgourmet - Dein Account ist angelegt worden.', {
                    theme: 'primary',
                    position: 'top-right',
                    duration: 10000,
                    action: {
                      text: 'X',
                      class: 'toastBtn',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                    icon: 'check'
                  })
                  api.login(vm.user).then(
                    response => {
                      vm.toggleModal()
                      api._saveToken(response.access_token)
                      vm.getAuthAccount()
                      vm.$toasted.success('Du bist jetzt angemeldet!', {
                        theme: 'primary',
                        position: 'top-right',
                        duration: 10000,
                        action: {
                          text: 'X',
                          class: 'toastBtn',
                          onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                          }
                        },
                        icon: 'check'
                      })
                    },
                    error => {
                      console.log(error)
                      vm.$toasted.error('Sie haben falsche Benutzerdaten eingegeben.', {
                        theme: 'primary',
                        position: 'top-right',
                        duration: 10000,
                        action: {
                          text: 'X',
                          class: 'toastBtn',
                          onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                          }
                        },
                        icon: 'close'
                      })
                    }
                  )
                },
                error => {
                  vm.saveToast.goAway(100)
                  vm.saveToast = null
                  if (error.response.data.errors.email[0] === 'The email has already been taken.') {
                    console.log('EMAIL ADDRESS TAKEN')
                    vm.bag.add('email', 'Diese Email-Adresse ist leider schon vergeben', 'duplicate')
                    vm.$toasted.error('Diese Email-Adresse ist leider schon vergeben', {
                      theme: 'primary',
                      position: 'top-right',
                      duration: 10000,
                      action: {
                        text: 'X',
                        class: 'toastBtn',
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                      icon: 'close'
                    })
                  } else {
                    vm.$toasted.error('Du hast einige Felder nicht korrekt ausgefüllt.', {
                      theme: 'primary',
                      position: 'top-right',
                      duration: 10000,
                      action: {
                        text: 'X',
                        class: 'toastBtn',
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                      icon: 'close'
                    })
                  }
                }
              )
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/Register.vue